module.exports = __webpack_public_path__ + "r-v3/img/x_white.18d36277.svg";